import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import { useMetaTags } from '../../services/useMetaTags';
import './errors.scss';

export default function NotFound() {
    const {t} = useTranslation();
    const homePath = '/';

    useMetaTags({
        title: `404 | ${t('app.title')}`,
        description: t('errorPages.notFound.subHeader'),
        metas: [{name: 'keywords', content: t('app.keywords')}],
    });

    return (
        <div className="spa-error-page spa-not-found-page">
            <div className="spa-not-found-bg" />
            <div className="spa-not-found-content">
                <div className="spa-not-found-image">
                    <img src="/img/404Page/404.svg" alt="404" />
                </div>
                <h1>{t('errorPages.notFound.header')}</h1>
                <h2>{t('errorPages.notFound.subHeader')}</h2>
                <p className="no-margin">{t('errorPages.notFound.reasonsTitle')}</p>
                <ul>
                    <li>{t('errorPages.notFound.reasons.movedOrRemoved')}</li>
                    <li>{t('errorPages.notFound.reasons.misspelling')}</li>
                </ul>
                <p>
                    {t('errorPages.notFound.mainPageTitle')}{' '}
                    <Link to={homePath} className="detailed">
                        {t('errorPages.notFound.mainPageLinkTitle')}
                    </Link>
                    .
                </p>
                <p>
                    {t('errorPages.notFound.questionsTitle')}{' '}
                    <a href="mailto:support@accemedin.com">support@accemedin.com</a>.
                </p>
                <Link to={homePath} className="btn">
                    {t('errorPages.notFound.backToMainTitle')}
                </Link>
            </div>
        </div>
    );
}
